import { Text } from "components";
import React from "react";
import { StatCardGradient, StatCardStyle, StatSection } from "../styles";

type Props = {
  title1: string;
  title2: string;
  value1: string;
  value2?: string;
  onClick?(): void;
};
export const StatCard: React.FC<Props> = ({
  title1,
  title2,
  value1,
  value2,
  onClick,
}) => {
  return (
    <div className={StatCardStyle} onClick={onClick}>
      <div className={StatSection}>
        <Text.Body3XS>{title1}</Text.Body3XS>
        <Text.Body3XS>{title2}</Text.Body3XS>
      </div>
      <div className={StatSection}>
        <Text.Body marginBottom={0}>{value1}</Text.Body>
        {value2 && (
          <Text.Body4XS marginTop={-1} color="highlight/3">
            {value2}
          </Text.Body4XS>
        )}
      </div>
      <Gradient />
    </div>
  );
};

function Gradient() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="180"
      height="60"
      viewBox="0 0 180 60"
      fill="none"
      className={StatCardGradient}
    >
      <g filter="url(#filter0_f_6983_2940)">
        <ellipse
          cx="22"
          cy="15"
          rx="94"
          ry="76"
          fill="#313131"
          fill-opacity="0.25"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_6983_2940"
          x="-136"
          y="-125"
          width="316"
          height="280"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="32"
            result="effect1_foregroundBlur_6983_2940"
          />
        </filter>
      </defs>
    </svg>
  );
}
